import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { IDocument } from '../../Interfaces/IDocument';

interface IPropsPreview {
  open: boolean;
  localDocumentObject: IDocument | null;
  onClose: () => void;
}

export const DocumentPreviewDialog: React.FC<IPropsPreview> = ({
  open,
  localDocumentObject,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogContent>
        {localDocumentObject !== null && localDocumentObject.Data ? (
          <iframe
            name={localDocumentObject.FileName}
            src={`data:application/pdf;headers=filename%3D${localDocumentObject.FileName};base64,${localDocumentObject.Data}`}
            width={850}
            height={600}
          />
        ) : (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height='50vh'
          >
            <CircularProgress />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={onClose}>
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
